import { types as sdkTypes } from '../../util/sdkLoader';

const { Money } = sdkTypes;

export const clearPriceFromSdk = packageItem => {
    const amount = packageItem.price.amount;
    packageItem.price = amount;
    return packageItem;
};

export const recreatePriceFromSdk = (packageItem, currency) => {
    const amountMoney = new Money(packageItem.price, currency);
    return { ...packageItem, price: amountMoney, currency };
};
